import * as React from "react";
import { Heading4, Paragraph3 } from "components/parts/Typography/cryptopedia";
import { Col, Row } from "components/layout/Grid";
import storage from "config/storage";
import appTheme from "themes/light";

enum FeedbackState {
  NORMAL,
  SUCCESS,
  HAS_SUBMITTED
}

const FEEDBACK_STORAGE_KEY = "cryptopedia_feedback";
const getSavedFeedbackState = () => {
  return JSON.parse(storage.get(FEEDBACK_STORAGE_KEY) || "{}");
};

const ArticleFeedback = ({ articleId }: { articleId: string }) => {
  const [feedbackState, setFeedbackState] = React.useState<FeedbackState>(
    () => {
      const feedbackMap = getSavedFeedbackState();
      if (feedbackMap[articleId]) {
        return FeedbackState.HAS_SUBMITTED;
      }

      return FeedbackState.NORMAL;
    }
  );

  const onSubmitFeedback = (isHelpful: boolean) => {
    const feedback = getSavedFeedbackState();
    feedback[articleId] = true;
    storage.set(FEEDBACK_STORAGE_KEY, JSON.stringify(feedback));
    setFeedbackState(FeedbackState.SUCCESS);
  };

  if (feedbackState === FeedbackState.HAS_SUBMITTED) {
    return null;
  }
  return (
    <div
      className={`rounded-lg border p-5 ${
        feedbackState === FeedbackState.NORMAL ? "hover:cursor-pointer" : ""
      } border-gray-300`}
    >
      <Paragraph3
        css={`
          margin: 0px;
        `}
      >
        Is this article helpful?
      </Paragraph3>
      <Row justifyContent="center" css={``}>
        {feedbackState === FeedbackState.NORMAL ? (
          <React.Fragment>
            <Col
              sm={6}
              justifyContent={"flex-end"}
              alignItems={"center"}
              css={`
                border-right: 1px solid ${appTheme.borderColors.secondary};
              `}
              onClick={() => onSubmitFeedback(true)}
            >
              <Heading4 bold>Yes</Heading4>
            </Col>
            <Col
              sm={6}
              justifyContent={"flex-start"}
              alignItems={"center"}
              onClick={() => onSubmitFeedback(false)}
            >
              <Heading4 bold>No</Heading4>
            </Col>
          </React.Fragment>
        ) : (
          <Heading4 bold>Thanks for your feedback.</Heading4>
        )}
      </Row>
    </div>
  );
};

export default ArticleFeedback;
